<script>
import { mapActions } from 'vuex';
import { frontendUrl } from '@/config';
import TableView from '@/components/elements/views/TableView';

export default {
    page: {
        title: 'Forums'
    },

    extends: TableView,

    data() {
        return {
            pageTitle: 'Forums'
        };
    },

    computed: {
        labels() {
            return [
                { value: 'name', width: '150px' },
                {
                    value: 'slug',
                    text: 'Link',
                    filter: val => `${frontendUrl}/forum/${val}`,
                    width: '150px'
                },
                {
                    value: 'isVisible',
                    text: 'Is Visible',
                    type: 'boolean',
                    isBadge: true,
                    width: '150px'
                },
                {
                    text: 'Language',
                    value: 'language.code',
                    type: 'enum',
                    isLanguage: true,
                    enumOptions: [
                        { value: 'he', label: 'Hebrew' },
                        { value: 'en', label: 'English' },
                        { value: 'ar', label: 'Arabic' },
                        { value: 'ru', label: 'Russian' }
                    ]
                },
                {
                    value: 'createdAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'forums/index',
            deleteItem: 'forums/destroy'
        }),

        onRowClick({ id }) {
            this.$router.push(`/forums/${id}/edit`);
        },

        onAddButtonClick() {
            this.$router.push('/forums/add');
        }
    }
};
</script>
